// extracted by mini-css-extract-plugin
module.exports = {"desktop-router":"container_desktop-router__26gIp"};